import WebUtils from "../../utils/WebUtils";

let baseUrl = WebUtils.getProctorBaseUrl();
let proctorPlatformBaseUrl = `${baseUrl}/proctor-platform/api/v1`;

export const getAssignedCandidatesApi = `${proctorPlatformBaseUrl}/jobGuide/getCandidateDetails`;
export const getGuideDetailsApi = `${proctorPlatformBaseUrl}/jobGuide/getGuideDetails`;
export const unAssignStudentsApi = `${proctorPlatformBaseUrl}/b2b/candidate/batch/unassignGuidesFromCandidates`;

//mock interview
export const createIDronaInterviewConfiguration = `${proctorPlatformBaseUrl}/iDrona/b2b/createIDronaInterviewConfiguration`;
export const getAllDronaConfig = `${proctorPlatformBaseUrl}/iDrona/b2b/getAllIDronaConfig`;
export const getIDronaConfig = `${proctorPlatformBaseUrl}/iDrona/getIDronaConfiguration`;
export const updateIDronaConfiguration = `${proctorPlatformBaseUrl}/iDrona/updateIDronaConfiguration`;

export const interviewAssignedBatchesApi = `${proctorPlatformBaseUrl}/iDrona/interviewAssignedBatches`;
export const getBatchAssignedInterviewCandidateDataApi = `${proctorPlatformBaseUrl}/iDrona/getBatchAssignedCandidateData`;

export const getIDronaDetailsApi = `${proctorPlatformBaseUrl}/iDrona/getIDronaDetails`;
export const getCandidateDetailsApi = `${proctorPlatformBaseUrl}/iDrona/getCandidateDetails`;
export const assignInterviewToBatches = `${proctorPlatformBaseUrl}/iDrona/b2b/assignInterviewFromBatches`;
export const assignInterviewToCandidates = `${proctorPlatformBaseUrl}/iDrona/b2b/assignInterviewToCandidates`;
export const getIMockInterviewData = `${proctorPlatformBaseUrl}/iDrona/getIMockInterviewData`;

export const unAssignMockInterviewFromBatch = `${proctorPlatformBaseUrl}/iDrona/b2b/unassignInterviewFromBatches`;
export const unAssignMockInterviewToCandidate = `${proctorPlatformBaseUrl}/iDrona/b2b/unassignInterviewToCandidates`;
export const getAssignedBatchData = `${proctorPlatformBaseUrl}/iDrona/getAssignedBatchData`;
export const getAssignedGuideBatchData = `${proctorPlatformBaseUrl}/jobGuide/getAssignedBatchData`;

export const getResourcesData = `${proctorPlatformBaseUrl}/b2b/candidate/batch/getResources`;
export const manageStudents = `${proctorPlatformBaseUrl}/b2b/candidate/batch/manageStudents`;

export const getOrgAdminDashboard = `${proctorPlatformBaseUrl}/organization/getOrgAdminDashboard`;
export const compareResumeJd = `${proctorPlatformBaseUrl}/cv/optimizer/compareResumeJd`;
export const getAllResumeJdMatch = `${proctorPlatformBaseUrl}/cv/optimizer/getAllResumeJdMatch`;
export const deleteResumeJdMatch = `${proctorPlatformBaseUrl}/cv/optimizer/deleteResumeJdMatch`;
export const renameResumeFile = `${proctorPlatformBaseUrl}/cv/optimizer/renameResumeFile`;
export const updateCandidateDetailsApi = `${proctorPlatformBaseUrl}/account/b2b/updateCandidateDetails`;
